import { useQuery } from '@tanstack/react-query';
import { globalSearch } from '@/services/api/search.api';

export function useGlobalSearch(q: string) {
  return useQuery({
    queryKey: ['global-search', q],
    queryFn: () => globalSearch(q),
    enabled: q.length >= 2,
    staleTime: 10_000,
  });
}
